import React  from 'react';
import AiImg from '@op/assets/svg/icon-ai.svg';
import { useRichText } from '../../hooks/useRichText';
import CardCommon from '@op/components/CardCommon';
import RichTextBlock from '@op/components/RichTextBlock';

import './index.scss';
import useLanguage from '@op/hooks/useLanguage'; 

interface Props {
  filter: any;
  gameInfo: any;
}

export default function FeedbackAnalysis({ filter, gameInfo }: Props) {
  const { formatMessage } = useLanguage();
  // 获取数据
  const { richText, richTextResp, modifyRichText, loading } = useRichText({
    filter,
    gameInfo,
  });
 

  return (
    <CardCommon>
      <RichTextBlock
        contentCard
        tabs={richText}
        tabsOptionStyle={{ margin: '10px 0px' }}
        isFull
        isEmpty={false}
        emptyHeight={148}
        loading={loading}
        loadingHeight={300}
        title={
          <div className="dbo-FeedbackAnalysis-title">
            <img className="dbo-FeedbackAnalysis-titleImg" src={AiImg} />
            {formatMessage('Official Account User Feedback Analysis')}
          </div>
        }
        onlyOneLanguage
        singleModel
        canEdit
        hasEmptyImg={false}
        emptyProps={{
          hasImg: false,
          hasTitle: false,
          contentCard: true,
        }}
        onConfirm={(_item: any) => {
          const promiseAll: Promise<Boolean>[] = [];
          _item.map((item: any) => {
            promiseAll.push(
              modifyRichText({
                id: richTextResp?.id,
                summary: item.text,
                summary_type: item.key,
                ...gameInfo,
              }),
            );
          });

          return Promise.all(promiseAll)
            .then(() => true)
            .catch((e) => false);
        }}
      ></RichTextBlock>
    </CardCommon>
  );
}
